/* 🤖 this file was generated by svg-to-ts*/
export const icoHtml5: {
  name: 'html-5';
  data: string;
} = {
  name: 'html-5',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 3h16l-1.566 16.162L12 21l-6.431-1.838L4 3zm5.402 7.314l-.173-2.035 7.533.002.173-1.963-9.87-.002.522 5.998h6.835l-.243 2.566-2.179.602-2.214-.605-.141-1.58H7.691l.247 3.123L12 17.506l4.028-1.08.558-6.111-7.184-.001z" fill="#909090"/></svg>`
};
